import React from "react";
import './App.css'

const Options = ({ payload, actionProvider }) => {
  const options = payload?.options || [];

  return (
    <div className="options-container">
      {options.map((opt, i) => (
        <button
          key={i}
          className="option-button"
          onClick={() => actionProvider.handleOptionClick(opt.nextId)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default Options;
